<p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" (onTabChange)="onTabChange($event)"
    [scrollable]="scrollable" class="h-full flex flex-col tabs-panels-root"
    [ngClass]="[customClass, variant === 'modern' ? 'tabs-panels--modern' : '', panelBorder === 'theme' ? 'tabs-panels-panel-border-theme' : panelBorder === 'default' ? 'tabs-panels-panel-border-default' : '']">
    <p-tablist [ngClass]="tabListClass">
        @if (showPrevIcon) {
        <ng-template #previcon>
            <i [class]="prevIconClass"></i>
        </ng-template>
        }

        @for (tab of visibleTabs; track tab.value) {
        <p-tab [value]="tab.value" [disabled]="tab.disabled" [attr.step-id]="tab.tour?.stepId"
            [class]="'flex items-center !gap-2 ' + (variant === 'modern' ? ' justify-center' : '') + (tab.customClass || '')"
            [pTooltip]="tab.tooltip || ''" [tooltipPosition]="tab.tooltipPosition || 'top'" [showDelay]="500">

            @if (tab.avatar) {
            <p-avatar [image]="tab.avatar" shape="circle" />
            }

            @if (tab.icon) {
            <app-icon [type]="tab.icon" [source]="tab.iconSource ?? 'primeng'"
                [size]="tab.iconSize ?? 'default'"></app-icon>
            }

            <span class="font-sans whitespace-nowrap">{{ tab.label }}</span>

            @if (tab.badge) {
            <p-badge [value]="tab.badge.toString()" [class]="tab.badgeClass || ''" />
            }
        </p-tab>
        }

        @if (showNextIcon) {
        <ng-template #nexticon>
            <i [class]="nextIconClass"></i>
        </ng-template>
        }

        @if (rightActions) {
        <!-- Slot for additional actions (e.g. Setup button) anchored to the right of the tab strip -->
        <div class="ml-auto flex items-center gap-2 px-2">
            <ng-container *ngTemplateOutlet="rightActions"></ng-container>
        </div>
        }
    </p-tablist>

    <p-tabpanels class="flex-1 overflow-hidden tabs-panels-panels" [ngClass]="tabPanelsClass">
        @for (tab of visibleTabs; track tab.value) {
        <p-tabpanel [value]="tab.value" class="h-full tabs-panels-panel">
            <ng-container #tabContentContainer></ng-container>
        </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>